import * as React from "react";
import { casesActions } from "configs";
import {
  FormWatcherCallback,
  useDispatch,
  useParams,
  useCurrentCase
} from "duck";
import { useUpdatePatientPhysicalExamMutation } from "requests";
import { FormValues } from "./types";

export const useUpdatePhysicalExam = () => {
  const { id: caseId } = useParams();

  const [update] = useUpdatePatientPhysicalExamMutation({
    ignoreResults: true
  });
  const dispatch = useDispatch();

  const { examId, shouldSync } = useCurrentCase(medicalCase => ({
    examId: medicalCase.data.client.patient.physicalExam._id,
    shouldSync: medicalCase.shouldSync
  }));

  return React.useCallback<FormWatcherCallback<FormValues>>(
    values => {
      dispatch(casesActions.updatePhysicalExam({ _id: caseId, data: values }));

      if (shouldSync) {
        return update({ variables: { input: { _id: examId, ...values } } });
      }
    },
    [update, examId, shouldSync]
  );
};
